/**
 * Pagination Component
 * Navigation controls for paginated tables
 */

import type { Pagination as PaginationType } from '@tender-monitor/shared/types/admin';

type PaginationProps = {
  pagination: PaginationType;
  onPageChange: (page: number) => void;
};

export function Pagination({ pagination, onPageChange }: PaginationProps) {
  const { page, totalPages, total, limit } = pagination;

  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, total);

  return (
    <div className="pagination">
      <button
        className="pagination__button"
        onClick={() => onPageChange(1)}
        disabled={page <= 1}
      >
        ««
      </button>
      <button
        className="pagination__button"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
      >
        «
      </button>

      <span className="pagination__info">
        {total > 0 ? `${startItem}-${endItem} z ${total}` : 'Brak wyników'}
      </span>

      <button
        className="pagination__button"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
      >
        »
      </button>
      <button
        className="pagination__button"
        onClick={() => onPageChange(totalPages)}
        disabled={page >= totalPages}
      >
        »»
      </button>
    </div>
  );
}
